<template>
    <article
        class="i-simple-select"
        v-click-outside="onClickOutside">
        <button
            class="i-simple-select__trigger"
            :class="{active:listVisible}"
            @click.prevent="showItems">
            <span v-html="triggerText"></span>
        </button>
        <ul
            v-if="listVisible"
            class="i-simple-select__list">
            <li
                v-for="(item, name, i) in items"
                :key="name"
                class="i-simple-select__item"
                @click="chooseItem(item, name)"
                v-html="item"></li>
        </ul>
    </article>
</template>

<script>
    import vClickOutside from 'click-outside-vue3'

    export default {
        name: 'SimpleSelect',
        directives: {
            clickOutside: vClickOutside.directive
        },
        props: ['items'],
        data() {
            return {
                triggerText: '',
                listVisible: false,
            }
        },
        methods: {
            showItems () {
                if (this.listVisible) {
                    this.listVisible = false
                    return
                }

                this.listVisible = true
            },

            onClickOutside () {
                this.listVisible = false
            },

            chooseItem (item, name) {
                this.triggerText = item
                this.listVisible = false
                this.$emit('tabSelected', item, name)
            }
        },
        beforeMount() {
            this.triggerText = this.items[0]
            if (!Array.isArray(this.items)) {
                const location = window.location.pathname.split('/').filter(Boolean)
                this.triggerText = this.items[location[location.length - 1]]
            }
        }
    }
</script>